import { useMemo } from 'react';

import { extractTrimmedValues } from 'ff/debrief/utils';
import { useDebriefRouter, useDebriefSelector } from 'ff/debrief/hooks';
import {
    useGetDebriefByTrackUUIDQuery,
    useGetTracklogByIdQuery,
} from 'ff/debrief/features/TracklogApi';
import DebriefSegments, {
    SegmentNode,
} from 'ff/debrief/features/DebriefSegments';

export const useDebriefSegments = () => {
    const router = useDebriefRouter();

    const selectedTracklogId = router.routeParams.tracklogId;
    const selectedSegment = useDebriefSelector(s => s.appSlice.selectedSegment);

    const { data: debrief, ...debriefQueryStatus } =
        useGetDebriefByTrackUUIDQuery(selectedTracklogId, {
            skip: !selectedTracklogId,
        });

    const { data: tracklog, ...tracklogQueryStatus } = useGetTracklogByIdQuery(
        selectedTracklogId,
        {
            skip: !selectedTracklogId,
        }
    );

    const tracklogData = extractTrimmedValues(tracklog);

    const tree = useMemo(() => {
        if (!debriefQueryStatus.isSuccess || !tracklogQueryStatus.isSuccess)
            return null;
        return new DebriefSegments({
            rootSegment: debrief.debriefSegments[0],
            trackPoints: tracklog.points.data,
            startTime: Math.floor(tracklogData.timestampStart),
            endTime:
                Math.floor(tracklogData.timestampStart) +
                tracklogData.totalDurationSeconds,
        });
    }, [debrief?.trackUuid, tracklog?.trackUuid]);

    const selectedSegmentPoints: SegmentNode = useMemo(() => {
        if (selectedSegment && tree) {
            const seg = tree.getSegmentById(selectedSegment.id);
            return seg?.label === 'Entire Flight' ? null : seg;
        } else {
            return null;
        }
    }, [tracklogQueryStatus.isSuccess, selectedSegment?.id]);

    return {
        selectedSegment: selectedSegmentPoints,
        segmentTree: tree,
    };
};
